<template>
    <section class="container mx-auto py-12 px-4">
        <div class="text-center mb-12">
            <h2
                class="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-green-900 mb-6">
                Our Gallery
            </h2>
        </div>

        <!-- Tabs Section -->
        <div class="flex justify-center mb-8">
            <button @click="toggleTab('photo')"
                :class="{ 'text-green-600': activeTab === 'photo', 'text-gray-600': activeTab !== 'photo' }"
                class="px-4 py-2 font-semibold text-lg">
                Photo Album
            </button>
            <button @click="toggleTab('video')"
                :class="{ 'text-green-600': activeTab === 'video', 'text-gray-600': activeTab !== 'video' }"
                class="px-4 py-2 font-semibold text-lg">
                Video Album
            </button>
        </div>

        <!-- Photo Album Tab -->
        <div v-if="activeTab === 'photo'" class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <!-- Placeholder Images for Photo Album -->
            <a data-fancybox="gallery" :href="`https://via.placeholder.com/600x400?text=Image+1`">
                <img src="https://via.placeholder.com/600x400?text=Image+1" alt="Image 1"
                    class="w-full h-auto rounded-lg shadow-lg">
            </a>
            <a data-fancybox="gallery" :href="`https://via.placeholder.com/600x400?text=Image+2`">
                <img src="https://via.placeholder.com/600x400?text=Image+2" alt="Image 2"
                    class="w-full h-auto rounded-lg shadow-lg">
            </a>
            <a data-fancybox="gallery" :href="`https://via.placeholder.com/600x400?text=Image+3`">
                <img src="https://via.placeholder.com/600x400?text=Image+3" alt="Image 3"
                    class="w-full h-auto rounded-lg shadow-lg">
            </a>
        </div>

        <!-- Video Album Tab -->
        <div v-if="activeTab === 'video'" class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div class="aspect-w-16 aspect-h-9 mb-6">
                <iframe :src="randomVideoUrl" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen class="w-full h-full rounded-lg"></iframe>
            </div>
            <div class="aspect-w-16 aspect-h-9 mb-6">
                <iframe :src="randomVideoUrl" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen class="w-full h-full rounded-lg"></iframe>
            </div>
            <div class="aspect-w-16 aspect-h-9 mb-6">
                <iframe :src="randomVideoUrl" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen class="w-full h-full rounded-lg"></iframe>
            </div>
            <div class="aspect-w-16 aspect-h-9 mb-6">
                <iframe :src="randomVideoUrl" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen class="w-full h-full rounded-lg"></iframe>
            </div>
            <div class="aspect-w-16 aspect-h-9 mb-6">
                <iframe :src="randomVideoUrl" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen class="w-full h-full rounded-lg"></iframe>
            </div>
            <div class="aspect-w-16 aspect-h-9 mb-6">
                <iframe :src="randomVideoUrl" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen class="w-full h-full rounded-lg"></iframe>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "SectionTwo",
    data() {
        return {
            activeTab: 'photo',
            videos: [
                'https://www.youtube.com/embed/sBws8MSXN7A',
            ],
            randomVideoUrl: '',
        };
    },
    methods: {
        toggleTab(tab) {
            this.activeTab = tab;
            if (tab === 'video') {
                this.setRandomVideo();
            }
        },
        setRandomVideo() {
            const randomIndex = Math.floor(Math.random() * this.videos.length);
            this.randomVideoUrl = this.videos[randomIndex];
        },
    },
    mounted() {
        this.setRandomVideo();
    },
};
</script>

<style scoped>
.container {
    max-width: 1200px;
}

.card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

button {
    transition: background-color 0.3s;
}

button:hover {
    background-color: #3490dc;
    color: white;
}

/* Image styling */
a img {
    transition: transform 0.3s ease-in-out;
}

a img:hover {
    transform: scale(1.05);
}

/* Fancybox Gallery Styling */
.fancybox-button {
    background-color: rgba(0, 0, 0, 0.6);
    color: white;
}
</style>